import { type MouseEventHandler, type FunctionComponent } from 'react';
import Close from 'dibs-icons/exports/Close.ts';
import classnames from 'classnames';
import { defineMessages, useIntl } from 'dibs-react-intl';

import styles from './main.module.css';
import dibsCss from 'dibs-css';

type ModalCloseButtonProps = {
    dataTn?: string;
    variation?: '24' | '40' | '20' | '20Circle' | '24Circle' | '48';
    onClick: MouseEventHandler;
    className?: string;
    disabled?: boolean;
    backgroundColor?: 'translucentWhite';
};

const messages = defineMessages({
    label: {
        id: 'modal.ModalCloseButton.label',
        defaultMessage: 'Close',
    },
});
export const ModalCloseButton: FunctionComponent<ModalCloseButtonProps> = ({
    variation = '24',
    className,
    dataTn,
    onClick,
    disabled,
    backgroundColor,
}) => {
    const intl = useIntl();

    const wrapperClass = classnames(
        dibsCss.absolute,
        dibsCss.topXsmall,
        dibsCss.rightXsmall,
        dibsCss.bgTransparent,
        dibsCss.borderNone,
        dibsCss.pXxsmall,
        dibsCss.fillNoir,
        className,
        disabled ? dibsCss.cursorNotAllowed : dibsCss.cursorPointer,
        {
            [styles.translucentWhite]: backgroundColor === 'translucentWhite',
        }
    );

    return (
        // this is a design system primitive, native button is intentional here
        // eslint-disable-next-line react/forbid-elements
        <button
            type="button"
            aria-label={intl.formatMessage(messages.label)}
            data-tn={dataTn || 'modal-close-button'}
            className={wrapperClass}
            onClick={disabled ? () => {} : onClick}
        >
            <Close variation={variation} dataTn="close" />
        </button>
    );
};
